import { useQuery } from "@apollo/client/react"; import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Searcher from './Searcher';
import { adaptProfesionalesArray, GET_PROFESIONALES_PAGINATED_RECLAMOS } from '../../../../../../data/graphQL/queries/Reclamos/getProfesionalesPaginated';
import { generateColumnsDefaultConfiguration } from '../../../../../../components/dataGrid/columnHelpers';
import { GET_ALL_TIPO_PROFESIONAL_ESPECIALIDAD } from '../../../../../../data/graphQL/queries/PlanCuidado/getTipoProfesionalEspecialidad';
import { adaptAllTipoProfesionalEspecialidadArray } from '../../../../../../adapters/allTipoProfesionalEspecialidadAdapter';


const ProfesionalField = ({
  onChange,
  profesionales,
  disabled,
  idDelegacion
}) => {

  const [tipoProfesionalesEspecialidad, setTipoProfesionalesEspecialidad] = useState([]);

  const columns = [
    {
      field: 'idProfesional',
      headerName: 'Id'
    },
    {
      field: 'nombre',
      headerName: 'Nombre',
      flex: 2
    },
    {
      field: 'apellido',
      headerName: 'Apellido',
      flex: 2
    },
    {
      field: 'tipoProfesional',
      headerName: 'Tipo',
      flex: 2
    },
    {
      field: 'idEspecialidad',
      headerName: 'Especialidad',
      flex: 2,
      valueGetter: (idEspecialidad) => {
        return tipoProfesionalesEspecialidad?.find((x) => x.id === idEspecialidad)?.displayName;
      }
    }];

  const { data: tipoProfesionalesEspecialidadData } = useQuery(GET_ALL_TIPO_PROFESIONAL_ESPECIALIDAD, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!tipoProfesionalesEspecialidadData) return;

    setTipoProfesionalesEspecialidad(adaptAllTipoProfesionalEspecialidadArray(tipoProfesionalesEspecialidadData));
  }, [tipoProfesionalesEspecialidadData]);

  const CONFIGURATED_COLUMNS = useMemo(() => generateColumnsDefaultConfiguration(columns), [columns, tipoProfesionalesEspecialidad]);

  const getSearchParams = useCallback((textValue) => {
    const filterDelegacion = idDelegacion ? {
      t_ProfesionalDel:  {
        some:  {
          idDelegacion:  {
            eq: idDelegacion
          }
        }
      }
    } : {};

    const searchParams = {
      and: [filterDelegacion]
    };

    if (textValue) {
      searchParams.and.push({
        or: [
          { idProfesional: { eq: parseInt(textValue) || 0 } },
          { nombre: { contains: textValue } },
          { apellido: { contains: textValue } },
          { idTipoProfesionalNavigation: { descripcion: { contains: textValue } } }]

      });
    }

    return searchParams;

  }, [idDelegacion]);

  const handleRowClick = (row) => {
    const newSet = new Set(profesionales);
    if (newSet.has(row.idProfesional)) {
      newSet.delete(row.idProfesional);
    } else {
      newSet.add(row.idProfesional);
    }
    onChange('profesionales', Array.from(newSet));
  };

  const onSelect = (newList) => {
    onChange('profesionales', newList);
  };

  const onDeleteRow = (rowId, rowEntityId) => {
    onChange('profesionales', [...profesionales.filter((p) => p !== rowEntityId)]);
  };

  const getEntityValue = (row) => {
    const value = !!row ? `${row.cod_Cliente} - ${row.nom_com}` : null;
    return value;
  };

  return <Searcher
    displayName='Profesionales'
    titleModal='Seleccionar profesionales'
    entityName='allProfesionalsWithoutFilters'
    entityId='idProfesional'
    columns={CONFIGURATED_COLUMNS}
    query={GET_PROFESIONALES_PAGINATED_RECLAMOS}
    adapter={adaptProfesionalesArray}
    getSearchParams={getSearchParams}
    onRowClick={handleRowClick}
    getEntityValue={getEntityValue}
    multiple
    entityIdValues={profesionales}
    onSelect={onSelect}
    onDeleteRow={onDeleteRow}
    disabled={disabled}
    dataGridTitle='Profesionales Seleccionados'
    dataGridButtonLabel='Agregar Profesionales' />;

};

export default ProfesionalField;